<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    console.log("CICD2.5")
    if (this._isMobile()) {
      // 手机端
      var w=window.innerWidth;//获取浏览器窗口宽度
      document.documentElement.style.fontSize=w/750*100+"px";
      // console.log(window.location.pathname, window.location.pathname != '/home')
      if(window.location.pathname.indexOf("mobile") < 0){
        // 非 PC 移动端页面公用的页面
        if(!this.publicPage()){
          this.$router.replace("/mobile/home");
        }
      }
    } else {
      // pc端
      if(window.location.pathname.indexOf("mobile") >= 0){
        this.$router.replace("/home");
      }
    }
    var browserTimer;
    let that = this
    window.addEventListener("resize",function(){
      clearTimeout(browserTimer);
      browserTimer=setTimeout(() =>{
        that.browserResize()
      },200)
    })
  },  
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
     /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
      );
      return flag;
    },
    browserResize() {
      var w=window.innerWidth;//获取浏览器窗口宽度
      if(this._isMobile()){
        var w=window.innerWidth;//获取浏览器窗口宽度
        document.documentElement.style.fontSize=w/750*100+"px";
        console.log(window.location.pathname)
        if(window.location.pathname.indexOf("mobile") < 0){
            if(!this.publicPage()){
            this.$router.replace("/mobile/home");
          }
        }
      } else{
        if(window.location.pathname.indexOf("mobile") >= 0){
          this.$router.replace("/home");
        }
      }
    },
    // 是否是PC 移动端公用的页面
    publicPage(){
      return ["/local-temporary-lander", "/switch-role", "/logout","/version-maintenance"].includes(window.location.pathname)
    }, 
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue